import { render, staticRenderFns } from "./Illustration.vue?vue&type=template&id=7baed180&"
import script from "./Illustration.vue?vue&type=script&lang=js&"
export * from "./Illustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7baed180')) {
      api.createRecord('7baed180', component.options)
    } else {
      api.reload('7baed180', component.options)
    }
    module.hot.accept("./Illustration.vue?vue&type=template&id=7baed180&", function () {
      api.rerender('7baed180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Illustration.vue"
export default component.exports